import { render, staticRenderFns } from "./inflowNewPage.vue?vue&type=template&id=6cee9b1a&scoped=true"
import script from "./inflowNewPage.vue?vue&type=script&lang=js"
export * from "./inflowNewPage.vue?vue&type=script&lang=js"
import style0 from "./inflowNewPage.vue?vue&type=style&index=0&id=6cee9b1a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cee9b1a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cee9b1a')) {
      api.createRecord('6cee9b1a', component.options)
    } else {
      api.reload('6cee9b1a', component.options)
    }
    module.hot.accept("./inflowNewPage.vue?vue&type=template&id=6cee9b1a&scoped=true", function () {
      api.rerender('6cee9b1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mallManagement/pageSetting/inflowNewPage.vue"
export default component.exports